import { memo } from 'react';

import { Badge } from '@components/badge';
import { useScopedTranslate } from '@locale/translate';

import { TravellerJourneyAction } from 'api/types';
import { ACTION_TYPES, getActionLabel } from 'ui/actions/action-config';
import { MoreItems, TravellerNodeActionCard } from 'ui/journey-builder/node-types/node-container';
import { NodeActions } from 'ui/traveller-journey-builder/node-types/common';
import { NodeContainer } from 'ui/traveller-journey-builder/node-types/node-container';
import { TravellerJourneyNode } from 'ui/traveller-journey-builder/node-types/types';

import { descriptionLocale } from './journey-node';

import { useConditionDescription } from '../condition-v2/hooks';
import { getConditionDescription, getConditionTooltip } from '../condition/journey-node';

const ACTION_TYPE = ACTION_TYPES.break_loop;

export const getDescription = (action: TravellerJourneyAction<typeof ACTION_TYPE>): string => {
  return getConditionDescription({
    values: action.values,
    styled: false,
    locale: descriptionLocale,
  });
};

export const Node = memo((node: TravellerJourneyNode<typeof ACTION_TYPE>) => {
  const { t } = useScopedTranslate(nodeLocale);

  const values = node.data?.values;
  const { descriptionText, isTextClamped } = useConditionDescription(values, descriptionLocale);

  return (
    <NodeContainer node={node}>
      <TravellerNodeActionCard
        node={node}
        label={getActionLabel(ACTION_TYPE)}
        descriptionText={descriptionText}
        tooltip={getConditionTooltip({ values, isTextClamped, locale: descriptionLocale })}
        renderBelowDescription={
          <>
            <MoreItems items={values?.conditions} />
            {node.data.isHalted && <Badge variant="neutral" text={t('conditionNotMet')} />}
          </>
        }
      >
        <NodeActions node={node} />
      </TravellerNodeActionCard>
    </NodeContainer>
  );
});

const nodeLocale = {
  en: {
    conditionNotMet: 'Condition not met',
  },
};
